/* eslint-disable no-param-reassign */
import Vue, { DirectiveOptions } from 'vue';
// 引入 loading 组件
import Loading from '../components/BaseLoading.vue';

function append(el: HTMLElement) {
  el.appendChild(el.instance.$el);
}
function remove(el: HTMLElement) {
  el.removeChild(el.instance.$el);
}

// 定义 loading 指令
const loadingDirective: DirectiveOptions = {
  inserted(el, binding) {
    // 创建 loading 组件构造函数
    const LoadingCtor = Vue.extend(Loading); // new 一个 loading组件实例
    const loadingInstance = new LoadingCtor(); // 组件挂载
    el.instance = loadingInstance.$mount(); // 传入值为 true 时才展示
    if (binding.value) {
      // 将组件挂载到绑定指令的元素上
      append(el);
    }
  },
  update(el, binding) {
    // 值更新时进行操作
    if (binding.value !== binding.oldValue) {
      if (binding.value) {
        append(el);
      } else {
        remove(el);
      }
    }
  },
};

export default loadingDirective;
